<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="sm">
            <template #body>
                 <div class="flex w-full mt-4">
                    <div class="flex justify-start w-full px-2">
                        <span class="f-bold"> {{ $t('document') | capitalize }} </span>
                    </div>
                </div>
                <div class="flex w-full">
                    <div class="flex justify-start w-full px-2">
                        <span> {{ document.name }} </span>
                    </div>
                </div>
                <div class="flex w-full mt-4">
                    <div class="flex justify-start w-full px-2">
                          <upload-file accept="application/pdf" :maxSize="2" @update="handleFiles" multiple class="w-full" />
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="submit">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue'
import BaseModal from '@/views/app/components/BaseModal'
import UploadFile from '@/views/app/components/UploadFile.vue'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    document: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['submit', 'input'])

const files = ref([])

watch(() => props.value, (newValue) => {
    if (newValue) {
        files.value = []
    }
})

const handleFiles = (inputFiles) => {
    files.value = inputFiles
}

const close = () => {
    emit('input', false)
}

const submit = () => {
    emit('submit', files.value)
}

</script>

